import BaseClient from '@/app/model/api/response/baseApiClient'

class NewsBoardContentCreateApi extends BaseClient {
  public doNewsBoardContentCreate (data: any, contentfile: any) {
    const path: string = '/v1/news-board-contents'
    const formData = new FormData()
    formData.append('news_board_id', data.news_board_id)
    formData.append('content_name', data.content_name)
    formData.append('record_date', data.record_date)
    formData.append('remarks', data.remarks)

    if (data.url !== '') {
      formData.append('content_url', data.url)
    } else {
      formData.append('content_file', contentfile)
    }
    /* 共通処理 */
    return super.donotUseContentType().setBody(formData).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new NewsBoardContentCreateApi()
